module.exports = __webpack_public_path__ + "static/img/22.f9c63cae.png";